export enum SettingsAiDataEventObjectsEnum {
  TOPICS_COPILOT_VIDEO = 'topics_copilot_video',
  SMART_QA_VIDEO = 'smart_qa_video',
  SMART_CSAT_VIDEO = 'smart_csat_video',
  ENABLE_AI_COPILOT_EDUCATION_TIP = 'enable_ai_copilot_education_tip',
  SMART_QA_INFOBOX_CREATE_RULE_LINK = 'smart_qa_infobox_create_rule_link',
  SMART_QA_ACTIVATION_BANNER_CREATE_RULE_LINK = 'smart_qa_activation_banner_create_rule_link',
  SMART_QA_ACTIVATION_BANNER_ANALYTICS_LINK = 'smart_qa_activation_banner_analytics_link',
  CONFIGURE_AI_COPILOT_STEPS_SELECT_INBOXES_TIP = 'configure_ai_copilot_steps_select_inboxes_tip',
  CONFIGURE_AI_COPILOT_STEPS_ADD_SOURCES_TIP = 'configure_ai_copilot_steps_add_sources_tip',
  CONFIGURE_AI_COPILOT_KNOWLEDGE_BASE_TIP = 'configure_ai_copilot_knowledge_base_tip',
  FEATURE_HELP_REQUEST_LINK = 'feature_help_request_link',
  AI_REPLY_LIST = 'ai_reply_list',
  AI_REPLY = 'ai_reply',
  AI_REPLY_OPEN_CONVERSATION = 'ai_reply_open_conversation',
  AI_REPLY_EXPORT = 'ai_reply_export',
  AI_REPLY_EXPORT_DOWNLOAD = 'ai_reply_export_download',
  AI_REPLY_REVIEW = 'ai_reply_review',
  AI_REPLY_UNREVIEW = 'ai_reply_unreview',
  AI_REPLY_SHOW_EDITS = 'ai_reply_show_edits',
  AI_COMMAND_CENTER_SOURCE = 'ai_command_center_source',
  AI_COMMAND_CENTER_KB_SCHEDULE_REVIEW = 'ai_command_center_kb_schedule_review',
  AI_COMMAND_CENTER_KB_UNPUBLISH = 'ai_command_center_kb_unpublish',
  AI_COMMAND_CENTER_SOURCE_STOP_USING_FACT = 'ai_command_center_source_stop_using_fact',
  AI_COMMAND_CENTER_SOURCE_RESTORE_FACT = 'ai_command_center_source_restore_fact',
  AI_COMMAND_CENTER_SOURCE_CREATE = 'ai_command_center_source_create',
  AI_COMMAND_CENTER_SOURCE_EDIT = 'ai_command_center_source_edit',
  AI_COMMAND_CENTER_SOURCE_DELETE = 'ai_command_center_source_delete',
  AI_COMMAND_CENTER_SOURCE_EXTERNAL = 'ai_command_center_source_external',
  AI_COMMAND_CENTER_SOURCE_NOTE_CREATE = 'ai_command_center_source_note_create',

  // Create AI teammate flow
  AI_TEAMMATE_SETUP_START = 'ai_teammate_setup_start',
  AI_TEAMMATE_SETUP_PAGE = 'ai_teammate_setup_page',
  AI_TEAMMATE_CREATE = 'ai_teammate_create',

  AI_TEAMMATE_PERFORMANCE = 'ai_teammate_performance',
  AI_TEAMMATE_PERFORMANCE_KEY_METRICS = 'ai_teammate_performance_key_metrics',
  AI_TEAMMATE_PERFORMANCE_REPLY_QUALITY_METRIC = 'ai_teammate_performance_reply_quality_metric',
  AI_TEAMMATE_PERFORMANCE_SEE_ALL = 'ai_teammate_performance_see_all',
  AI_TEAMMATE_PERFORMANCE_VIEW_REPLIES = 'ai_teammate_performance_view_replies',

  // Manage Sources Dialog
  MANAGE_SOURCES_DIALOG = 'manage_sources_dialog',

  // Knowledge Source Sync
  KNOWLEDGE_SOURCE_SYNC_TRIGGERED = 'knowledge_source_sync_triggered',
  KNOWLEDGE_SOURCE_SYNC_COMPLETED = 'knowledge_source_sync_completed',
  KNOWLEDGE_SOURCE_SYNC_FAILED = 'knowledge_source_sync_failed',

  // Knowledge Sources Page
  KNOWLEDGE_SOURCES_PAGE = 'knowledge_sources_page',
  KNOWLEDGE_SOURCES_MANAGE_BUTTON = 'knowledge_sources_manage_button',
  KNOWLEDGE_SOURCES_SETTINGS = 'knowledge_sources_settings',
  KNOWLEDGE_SOURCES_SETTINGS_ERROR = 'knowledge_sources_settings_error',

  // Add Sources Button
  KNOWLEDGE_SOURCES_ADD_BUTTON = 'knowledge_sources_add_button',
  KNOWLEDGE_SOURCES_ADD_OPTION = 'knowledge_sources_add_option',
  KNOWLEDGE_SOURCES_SOURCE_ADDED = 'knowledge_sources_source_added',

  // Knowledge Sources Activation Banner
  KNOWLEDGE_SOURCES_ACTIVATION_BANNER = 'knowledge_sources_activation_banner',
}
